import type { Product } from '@virginexperiencedays/products';

type Categories = {
  text: string;
  href: string;
  isExternal: boolean;
};

type CategoriesExtractorProps = {
  slugNameMap: Record<string, string>;
};

export const categoriesExtractor = (
  product: Product,
  { slugNameMap }: CategoriesExtractorProps
): Categories[] => {
  const categories = product?.categories?.length ? product.categories : [];
  const getSlugName = (slug: string) => slugNameMap?.[slug] ?? slug.replace(/-/gi, ' ');

  const formattedCategories = categories.slice(0, 10).map((category) => ({
    text: getSlugName(category),
    href: `/${category}`,
    isExternal: false,
  }));

  return formattedCategories;
};
